import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {PaymentRequestReminderModel} from "../../api/entity/paymentRequestReminder.model";
import {PaymentRequestReminderConverter} from "../../api/entity/converter/paymentRequestReminder.converter";
import {CustomizeHttpUrlGenerator} from "../../../../../../../store/core/url/customizeHttpUrlGenerator";

@Injectable()
export class PaymentRequestReminderDataService extends AbstractDataServiceV2<PaymentRequestReminderModel, PaymentRequestReminderConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig, converter: PaymentRequestReminderConverter) {
        super('PaymentRequestReminder', http, httpUrlGenerator, logger, config, converter);
    }
}
